import React, { useState, useEffect } from "react";
import IntroHero from "./components/sections/IntroHero";
import Highlights from "./components/sections/Highlights";
import CertificateCta from "./components/sections/CertificateCta";
import Testimonials from "./components/sections/Testimonials";
import StudentTestimonialVideo from "./components/sections/StudentTestimonialVideo";
import StarterVideo from "./components/sections/StarterVideo";
import Plans from "./components/sections/Plans";
import Contact from "./components/sections/Contact";
import Footer from "./components/layout/Footer";
import AboutPage from "./pages/AboutPage";
import BlogsPage from "./pages/BlogsPage";
import ResourcesPage from "./pages/ResourcesPage";
import BlogDetailPage from "./pages/BlogDetailPage";
import SongDetailPage from "./pages/SongDetailPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@5.4.296/build/pdf.worker.min.mjs`;

type Page = "home" | "about" | "blogs" | "resources" | "blog-detail" | "song-detail" | "terms" | "privacy";

function App() {
  const [currentPage, setCurrentPage] = useState<Page>("home");

  useEffect(() => {
    // Handle hash navigation
    const handleHashChange = () => {
      const hash = window.location.hash.split("?")[0]; // Get hash without query params
      if (hash === "#about") {
        setCurrentPage("about");
      } else if (hash === "#blogs") {
        setCurrentPage("blogs");
      } else if (hash === "#resources") {
        setCurrentPage("resources");
      } else if (hash === "#blog-detail") {
        setCurrentPage("blog-detail");
      } else if (hash === "#song-detail") {
        setCurrentPage("song-detail");
      } else if (hash === "#terms") {
        setCurrentPage("terms");
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else if (hash === "#privacy") {
        setCurrentPage("privacy");
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        setCurrentPage("home");
        // If navigating to a section on home page, scroll to it after a brief delay
        if (hash && hash !== "#home") {
          setTimeout(() => {
            const element = document.querySelector(hash);
            if (element) {
              const headerOffset = 80;
              const elementPosition = element.getBoundingClientRect().top;
              const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
              window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
              });
            }
          }, 150);
        }
      }
    };

    // Handle click events on navigation links
    // const handleLinkClick = (e: MouseEvent) => {
    //   const target = e.target as HTMLElement;
    //   const link = target.closest("a[href^='#']") as HTMLAnchorElement;
    //   if (link) {
    //     const hash = link.getAttribute("href");
    //     const hashBase = hash?.split("?")[0];
    //     if (
    //       hash &&
    //       hash !== "#home" &&
    //       (currentPage === "about" ||
    //         currentPage === "blogs" ||
    //         currentPage === "resources" ||
    //         currentPage === "blog-detail" ||
    //         currentPage === "song-detail" ||
    //         currentPage === "terms" ||
    //         currentPage === "privacy")
    //     ) {
    //       e.preventDefault();
    //       setCurrentPage("home");
    //       window.history.pushState(null, "", hash);
    //       // Wait for page to render, then scroll
    //       setTimeout(() => {
    //         const element = document.querySelector(hash);
    //         if (element) {
    //           const headerOffset = 80;
    //           const elementPosition = element.getBoundingClientRect().top;
    //           const offsetPosition =
    //             elementPosition + window.pageYOffset - headerOffset;
    //           window.scrollTo({
    //             top: offsetPosition,
    //             behavior: "smooth",
    //           });
    //         }
    //       }, 150);
    //     }
    //   }
    // };

    // Check initial hash
    handleHashChange();

    // Listen for hash changes
    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [currentPage]);


  if (currentPage === "about") {
    return <AboutPage />;
  }

  if (currentPage === "blogs") {
    return <BlogsPage />;
  }

  if (currentPage === "resources") {
    return <ResourcesPage />;
  }

  if (currentPage === "blog-detail") {
    return <BlogDetailPage />;
  }

  if (currentPage === "song-detail") {
    return <SongDetailPage />;
  }

  if (currentPage === "terms") {
    return <TermsPage />;
  }

  if (currentPage === "privacy") {
    return <PrivacyPage />;
  }

  return (
    <div className="App min-h-screen bg-primary">
      <IntroHero />
      <Highlights />
      <CertificateCta />
      <StarterVideo />
      {/* <JourneyFlow /> */}
      <StudentTestimonialVideo />
      <Plans />
      <Testimonials />
      {/* <StudentVideos /> */}
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
